import React from "react"
import "./ScrollArea.css"

const ScrollArea = ({ children, className = "" }) => {
  return <div className={`scroll-area ${className}`}>{children}</div>
}

export default ScrollArea
